export const LOGIN_ACTIONS = {
	LOGIN_ACTIONS_LOGIN_USER: 'LOGIN_ACTIONS_LOGIN_USER',
	LOGIN_ACTIONS_RECEIVE_AUTH_LOGIN_USER: 'LOGIN_ACTIONS_LOGIN_ACTIONS_RECEIVE_AUTH_LOGIN_USER',
	LOGIN_ACTIONS_LOGOUT: 'LOGIN_ACTIONS_LOGOUT',
	LOGIN_ACTIONS_RESET_VALUES: 'LOGIN_ACTIONS_RESET_VALUES',
	LOGIN_ACTIONS_VALIDATION_BY_CODE: 'LOGIN_ACTIONS_LOGIN_ACTIONS_VALIDATION_BY_CODE',
	LOGIN_ACTIONS_RECEIVE_VALIDATION_BY_CODE: 'LOGIN_ACTIONS_LOGIN_ACTIONS_RECEIVE_VALIDATION_BY_CODE',

	LOGIN_ACTIONS_LOGIN_RESET: 'LOGIN_ACTIONS_LOGIN_RESET',
	LOGIN_ACTIONS_HANDLE_USER_INFO: 'LOGIN_ACTIONS_HANDLE_USER_INFO',

	LOGIN_ACTIONS_LOGIN_VALIDATE_FIELDS: 'LOGIN_ACTIONS_LOGIN_VALIDATE_FIELDS',
	LOGIN_ACTIONS_RESET_VALIDATE_FIELDS: 'LOGIN_ACTIONS_RESET_VALIDATE_FIELDS',

	LOGIN_ACTIONS_HANDLE_CODE: 'LOGIN_ACTIONS_HANDLE_CODE',
	LOGIN_ACTIONS_SEND_CODE: 'LOGIN_ACTIONS_SEND_CODE',
	LOGIN_ACTIONS_RECEIVE_PUT_LOGIN_CODE: 'LOGIN_ACTIONS_RECEIVE_LOGIN_CODE',

	LOGIN_ACTIONS_COUNTER_ATTEMPS: 'LOGIN_ACTIONS_COUNTER_ATTEMPS',

	LOGIN_ACTIONS_SHOW_PASSWORD: 'LOGIN_ACTIONS_SHOW_PASSWORD',

	LOGIN_ACTIONS_LOGIN_RESET_DISABLED: 'LOGIN_ACTIONS_LOGIN_RESET_DISABLED',

	LOGIN_ACTIONS_RESET_VALIDATION_CHALLENGE: 'LOGIN_ACTIONS_RESET_VALIDATION_CHALLENGE',

	LOGIN_ACTIONS_HANDLE_FIELDS_FILTEREDS: 'LOGIN_ACTIONS_HANDLE_FIELDS_FILTEREDS',

	LOGIN_ACTIONS_RESET_PASSWORD: 'LOGIN_ACTIONS_RESET_PASSWORD',

	LOGIN_ACTIONS_RECEIVE_RESPONSE_RESET_PASSWORD: 'LOGIN_ACTIONS_RECEIVE_RESPONSE_RESET_PASSWORD',
	LOGIN_ACTIONS_RESET_VALUES_RECOVERY_PASSWORD: 'LOGIN_ACTIONS_RESET_VALUES_RECOVERY_PASSWORD',

	LOGIN_ACTIONS_VALIDATE_ACQUIRERS_AVAILABLE: 'LOGIN_ACTIONS_VALIDATE_ACQUIRERS_AVAILABLE',
	LOGIN_ACTIONS_VALIDATE_RECEIVE_RESPONSE_ACQUIRERS_AVAILABLE: 'LOGIN_ACTIONS_VALIDATE_RECEIVE_RESPONSE_ACQUIRERS_AVAILABLE',

	LOGIN_ACTIONS_RESENT_CODE: 'LOGIN_ACTIONS_RESENT_CODE',
	LOGIN_ACTIONS_RECEIVE_RESPONSE_RESENT_CODE: 'LOGIN_ACTIONS_RECEIVE_RESPONSE_RESENT_CODE',

	LOGIN_ACTIONS_RESET_VALUES_RESENT_CODE: 'LOGIN_ACTIONS_RESET_VALUES_RESENT_CODE'
}

export const HOME_ACTIONS = {
  HOME_ACTIONS_RESET_PROFILE_RESET_VALUES: 'HOME_ACTIONS_RESET_PROFILE_RESET_VALUES',
	HOME_ACTIONS_UPDATE_QUERIES: 'HOME_ACTIONS_UPDATE_QUERIES',
	HOME_ACTIONS_LIST_BRANDS_BY_ACQUIRER: 'HOME_ACTIONS_LIST_BRANDS_BY_ACQUIRER',
	HOME_ACTIONS_RECEIVE_RESPONSE_LIST_BRANDS_BY_ACQUIRER: 'HOME_ACTIONS_RECEIVE_RESPONSE_LIST_BRANDS_BY_ACQUIRER',
	HOME_ACTIONS_LIST_COUNTRIES_BY_ACQUIRER: 'HOME_ACTIONS_LIST_COUNTRIES_BY_ACQUIRER',
	HOME_ACTIONS_RECEIVE_RESPONSE_LIST_COUNTRIES: 'HOME_ACTIONS_RECEIVE_RESPONSE_LIST_COUNTRIES',
	HOME_ACTIONS_LIST_ACQUIRERS_LOADING: 'HOME_ACTIONS_LIST_ACQUIRERS_LOADING',
	HOME_ACTIONS_LIST_ACQUIRERS_LOADED: 'HOME_ACTIONS_LIST_ACQUIRERS_LOADED',
	HOME_ACTIONS_RESET_BRANDS: 'HOME_ACTIONS_RESET_BRANDS',
	HOME_ACTIONS_SELECT_ACQUIRER_DASHBOARD: 'HOME_ACTIONS_SELECT_ACQUIRER_DASHBOARD',
	HOME_ACTIONS_GET_USER_ACTIVE: 'HOME_ACTIONS_GET_USER_ACTIVE',
  HOME_ACTIONS_RECEIVE_RESPONSE_GET_USER_ACTIVE: 'HOME_ACTIONS_RECEIVE_RESPONSE_GET_USER_ACTIVE',
  HOME_ACTION_HANDLE_UPDATE_INFO_USER_UI: 'HOME_ACTION_HANDLE_UPDATE_INFO_USER_UI',

  HOME_ACTION_UPDATE_USER_INFO_PROFILE: 'HOME_ACTION_UPDATE_USER_INFO_PROFILE',
  HOME_ACTIONS_RECEIVE_RESPONSE_UPDATE_USER_INFO_PROFILE: 'v',

  HOME_ACTIONS_RESET_VALUES_UPDATED: 'HOME_ACTIONS_RESET_VALUES_UPDATED',

	HOME_ACTIONS_HANDLE_PICTURE_ACQUIRER: 'HOME_ACTIONS_HANDLE_PICTURE_ACQUIRER',
	HOME_ACTIONS_RECEIVE_RESPONSE_HANDLE_PICTURE_ACQUIRER: 'HOME_ACTIONS_RECEIVE_RESPONSE_HANDLE_PICTURE_ACQUIRER'
}

export const MERCHANTS_ACTIONS = {
	MERCHANTS_ACTIONS_GO_TO_PAGE: 'MERCHANTS_ACTIONS_GO_TO_PAGE',
	MERCHANTS_ACTIONS_UPDATE_BODY_NEW_MERCHANT: 'MERCHANTS_ACTIONS_UPDATE_BODY_NEW_MERCHANT',
	MERCHANTS_ACTIONS_DELETE_FILTERS: 'MERCHANTS_ACTIONS_DELETE_FILTERS',
	MERCHANTS_ACTIONS_SHOW_FORM_REGISTER: 'MERCHANTS_ACTIONS_SHOW_FORM_REGISTER',
	MERCHANTS_ACTIONS_SENT_FILTER_LIST: 'MERCHANTS_ACTIONS_SENT_FILTER_LIST',
	MERCHANTS_ACTIONS_RECEIVE_RESPONSE_FILTER_LIST: 'MERCHANTS_ACTIONS_RECEIVE_RESPONSE_FILTER_LIST',
	MERCHANTS_ACTIONS_HANDLE_VALUES_FILTERS: 'MERCHANTS_ACTIONS_HANDLE_VALUES_FILTERS',
	MERCHANTS_ACTIONS_REGISTER_MERCHANT: 'MERCHANTS_ACTIONS_REGISTER_MERCHANT',
	MERCHANTS_ACTIONS_RECEIVE_RESPONSE_REGISTER_MERCHANT: 'MERCHANTS_ACTIONS_RECEIVE_RESPONSE_REGISTER_MERCHANT',
	MERCHANTS_ACTIONS_HANDLE_FIELDS_REGISTER_MERCHANT: 'MERCHANTS_ACTIONS_HANDLE_FIELDS_REGISTER_MERCHANT',
	MERCHANTS_ACTIONS_HANDLE_ECOMMERCE_CODE: 'MERCHANTS_ACTIONS_HANDLE_ECOMMERCE_CODE',
	MERCHANTS_ACTIONS_UPDATE_BRAND_SELECTED: 'MERCHANTS_ACTIONS_UPDATE_BRAND_SELECTED',
	MERCHANTS_ACTIONS_UPDATE_CURRENCY_SELECTED: 'MERCHANTS_ACTIONS_UPDATE_CURRENCY_SELECTED',

	MERCHANTS_ACTIONS_HANDLE_FIELDS_UPLOAD_MERCHANT: 'MERCHANTS_ACTIONS_HANDLE_FIELDS_UPLOAD_MERCHANT',

	MERCHANTS_ACTIONS_GET_MERCHANT_INFO: 'MERCHANTS_ACTIONS_GET_MERCHANT_INFO',
	MERCHANTS_ACTIONS_UPDATE_CURRENCIES_EDIT_MERCHANT: 'MERCHANTS_ACTIONS_UPDATE_CURRENCIES_EDIT_MERCHANT',
	MERCHANTS_ACTIONS_RECEIVE_RESPONSE_UPDATE_CURRENCIES_EDIT_MERCHANT: 'MERCHANTS_ACTIONS_RECEIVE_RESPONSE_UPDATE_CURRENCIES_EDIT_MERCHANT',
	MERCHANTS_ACTIONS_RECEIVE_RESPONSE_GET_MERCHANT_INFO: 'MERCHANTS_ACTIONS_RECEIVE_RESPONSE_GET_MERCHANT_INFO',

	MERCHANTS_ACTIONS_HANDLE_VALUES_BULK_LOAD_FILTERS: 'MERCHANTS_ACTIONS_HANDLE_VALUES_BULK_LOAD_FILTERS',

	MERCHANTS_ACTIONS_GENERATE_BRANDS_INITIAL: 'MERCHANTS_ACTIONS_GENERATE_BRANDS_INITIAL',
	MERCHANTS_ACTIONS_UPDATE_NEW_REGISTER_FIELDS: 'MERCHANTS_ACTIONS_UPDATE_NEW_REGISTER_FIELDS',

	MERCHANTS_ACTIONS_HANDLE_FILE: 'MERCHANTS_ACTIONS_HANDLE_FILE',

	MERCHANTS_ACTIONS_UPLOAD_FILE: 'MERCHANTS_ACTIONS_UPLOAD_FILE',
	MERCHANTS_ACTIONS_RECEIVE_RESPONSE_UPLOAD_FILE: 'MERCHANTS_ACTIONS_RECEIVE_RESPONSE_UPLOAD_FILE',

	MERCHANTS_ACTIONS_INCREASE_PERCENT: 'INCREASE_PERCENT',

	MERCHANTS_ACTIONS_EDIT_UPDATE_ALL_BODY: 'MERCHANTS_ACTIONS_EDIT_UPDATE_ALL_BODY',

	MERCHANTS_ACTIONS_PUT_BATCH: 'MERCHANTS_ACTIONS_PUT_BATCH',
	MERCHANTS_ACTIONS_RECEIVE_RESPONSE_PUT_BATCH: 'MERCHANTS_ACTIONS_RECEIVE_RESPONSE_PUT_BATCH',

	MERCHANTS_ACTIONS_EDIT_CURRENCY_SELECTED: 'MERCHANTS_ACTIONS_EDIT_CURRENCY_SELECTED',
	MERCHANTS_ACTIONS_EDIT_BRAND_SELECTED: 'MERCHANTS_ACTIONS_EDIT_BRAND_SELECTED',
	MERCHANTS_ACTIONS_EDIT_HANDLE_ECOMMERCE_CODE: 'MERCHANTS_ACTIONS_EDIT_HANDLE_ECOMMERCE_CODE',

	MERCHANTS_ACTIONS_RESET_EDIT_MERCHANT_VALUES: 'MERCHANTS_ACTIONS_RESET_EDIT_MERCHANT_VALUES',

	MERCHANTS_ACTIONS_BRANDS_CURRENCIES_MERCHANT_EDIT: 'MERCHANTS_ACTIONS_BRANDS_CURRENCIES_MERCHANT_EDIT',

	MERCHANTS_ACTIONS_EDIT_MERCHANT: 'MERCHANTS_ACTIONS_EDIT_MERCHANT',
	MERCHANTS_ACTIONS_RECEIVE_RESPONSE_EDIT_MERCHANT: 'MERCHANTS_ACTIONS_RECEIVE_RESPONSE_EDIT_MERCHANT',
	MERCHANTS_ACTIONS_CLEAN_ALL_FILTERS: 'MERCHANTS_ACTIONS_CLEAN_ALL_FILTERS',

  MERCHANTS_ACTIONS_SHOW_MODAL_REGISTER: 'MERCHANTS_ACTIONS_SHOW_MODAL_REGISTER',
  MERCHANTS_ACTIONS_CLOSE_MODAL_REGISTER: 'MERCHANTS_ACTIONS_CLOSE_MODAL_REGISTER',

	MERCHANTS_ACTIONS_RESET_VALUES_REGISTER_MERCHANT: 'MERCHANTS_ACTIONS_RESET_VALUES_REGISTER_MERCHANT',
	MERCHANTS_ACTIONS_NEXT_PAGE: 'MERCHANTS_ACTIONS_NEXT_PAGE',
	MERCHANTS_ACTIONS_BACK_PAGE: 'MERCHANTS_ACTIONS_BACK_PAGE',
	MERCHANTS_ACTIONS_UPDATE_FILTERS: 'MERCHANTS_ACTIONS_UPDATE_FILTERS',
  MERCHANTS_ACTIONS_CHANGE_ORDER: 'MERCHANTS_ACTIONS_CHANGE_ORDER',
	//BULK LOAD
	MERCHANTS_ACTIONS_RESET_CORRECT_FORMAT: 'MERCHANTS_ACTIONS_RESET_CORRECT_FORMAT',
	MERCHANTS_ACTIONS_RESET_VALUES_BULK_LOAD: '	MERCHANTS_ACTIONS_RESET_VALUES_BULK_LOAD',
	MERCHANTS_ACTIONS_RESET_VALUES: 'MERCHANTS_ACTIONS_RESET_VALUES',
	MERCHANTS_ACTIONS_GET_URL_UPLOAD_FILE: 'MERCHANTS_ACTIONS_GET_URL_UPLOAD_FILE',
	MERCHANTS_ACTIONS_RECEIVE_RESPONSE_GET_URL_UPLOAD_FILE: 'MERCHANTS_ACTIONS_RECEIVE_RESPONSE_GET_URL_UPLOAD_FILE',
	MERCHANTS_ACTIONS_SENT_FILE_TO_SERVER: 'MERCHANTS_ACTIONS_SENT_FILE_TO_SERVER',
	MERCHANTS_ACTIONS_RECEIVE_RESPONSE_SENT_FILE_TO_SERVER: 'MERCHANTS_ACTIONS_SENT_FILE_TO_SERVER',
	MERCHANTS_ACTIONS_SENT_ALL_FILTERS: 'MERCHANTS_ACTIONS_SENT_ALL_FILTERS',
	MERCHANTS_ACTIONS_RECEIVE_RESPONSE_SENT_ALL_FILTERS: 'MERCHANTS_ACTIONS_RECEIVE_RESPONSE_SENT_ALL_FILTERS',
	MERCHANTS_ACTIONS_UPDATE_PERCENT_LOADED: 'MERCHANTS_ACTIONS_UPDATE_PERCENT_LOADED',
	MERCHANTS_ACTIONS_DISABLED_BUTTON_UPLOAD: 'MERCHANTS_ACTIONS_DISABLED_BUTTON_UPLOAD',
	MERCHANTS_ACTIONS_GENERATE_URL_DOWNLOAD_FILE: 'MERCHANTS_ACTIONS_GENERATE_URL_DOWNLOAD_FILE',
	MERCHANTS_ACTIONS_RECEIVE_RESPONSE_GENERATE_URL_DOWNLOAD_FILE: 'MERCHANTS_ACTIONS_RECEIVE_RESPONSE_GENERATE_URL_DOWNLOAD_FILE',
	MERCHANTS_ACTIONS_DOWNLOAD_FILE: 'MERCHANTS_ACTIONS_DOWNLOAD_FILE',
	MERCHANTS_ACTIONS_CLOSE_MODAL_EDIT_MERCHANT: 'MERCHANTS_ACTIONS_CLOSE_MODAL_EDIT_MERCHANT',
	MERCHANTS_ACTIONS_RECEIVE_RESPONSE_DOWNLOAD_FILE: 'MERCHANTS_ACTIONS_RECEIVE_RESPONSE_DOWNLOAD_FILE',
	MERCHANTS_ACTIONS_RESET_VALUES_MERCHANTS_FILTERS: 'MERCHANTS_ACTIONS_RESET_VALUES_MERCHANTS_FILTERS',
  MERCHANTS_ACTIONS_BULK_LOAD_DELETE_FILTERS: 'MERCHANTS_ACTIONS_BULK_LOAD_DELETE_FILTERS',
  MERCHANTS_ACTIONS_BULK_LOAD_NEXT_PAGE: 'MERCHANTS_ACTIONS_BULK_LOAD_NEXT_PAGE',
  MERCHANTS_ACTIONS_BULK_LOAD_GO_TO_PAGE: 'MERCHANTS_ACTIONS_BULK_LOAD_GO_TO_PAGE',
  MERCHANTS_ACTIONS_BULK_LOAD_BACK_PAGE: 'MERCHANTS_ACTIONS_BULK_LOAD_BACK_PAGE',

	//EXPORT MERCHANTS
	MERCHANTS_ACTIONS_EXPORT_FILE: "MERCHANTS_ACTIONS_EXPORT_FILE",
	MERCHANTS_ACTIONS_RECEIVE_EXPORT_FILE: "MERCHANTS_ACTIONS_RECEIVE_EXPORT_FILE",
	MERCHANTS_ACTIONS_RESET_EXPORT_FILE: "MERCHANTS_ACTIONS_RESET_EXPORT_FILE"

}

export const TRANSACTION_ACTIONS = {
	TRANSACTION_ACTIONS_SENT_FILTERS_LIST_TRANSACTIONS: 'TRANSACTION_ACTIONS_SENT_FILTERS_LIST_TRANSACTIONS',
	TRANSACTION_ACTIONS_RECEIVE_RESPONSE_SENT_FILTERS_LIST_TRANSACTIONS: 'TRANSACTION_ACTIONS_RECEIVE_RESPONSE_SENT_FILTERS_LIST_TRANSACTIONS',

	TRANSACTION_ACTIONS_GET_INFO: 'TRANSACTION_ACTIONS_GET_INFO',
	TRANSACTION_ACTIONS_RECEIVE_RESPONSE_GET_INFO: 'TRANSACTION_ACTIONS_RECEIVE_RESPONSE_GET_INFO',
	
	TRANSACTION_ACTIONS_NEXT_PAGE: 'TRANSACTION_ACTIONS_NEXT_PAGE',
	TRANSACTION_ACTIONS_BACK_PAGE: 'TRANSACTION_ACTIONS_BACK_PAGE',

	TRANSACTION_ACTIONS_GO_TO_PAGE: 'TRANSACTION_ACTIONS_GO_TO_PAGE',

	TRANSACTION_ACTIONS_FILTERS_RESET: 'TRANSACTION_ACTIONS_FILTERS_RESET',
	TRANSACTION_ACTIONS_HANDLE_FIELDS_FILTEREDS: 'TRANSACTION_ACTIONS_HANDLE_FIELDS_FILTEREDS',

	TRANSACTION_ACTIONS_DELETE_FILTERS: 'TRANSACTION_ACTIONS_DELETE_FILTERS',
  	TRANSACTION_ACTIONS_CHANGE_ORDER: 'TRANSACTION_ACTIONS_CHANGE_ORDER',

	//EXPORT FILE TRANSACTIONS
	TRANSACTION_ACTIONS_EXPORT_FILE: 'TRANSACTION_ACTIONS_EXPORT_FILE',
	TRANSACTION_ACTIONS_RECEIVE_EXPORT_FILE: 'TRANSACTION_ACTIONS_RECEIVE_EXPORT_FILE',
	TRANSACTION_ACTIONS_RESET_EXPORT_FILE: 'TRANSACTION_ACTIONS_RESET_EXPORT_FILE',
}

export const REGISTER_ACTIONS = {
	REGISTER_ACTIONS_REGISTER_USER: 'REGISTER_ACTIONS_REGISTER_USER',
	REGISTER_ACTIONS_RECEIVE_RESPONSE: 'REGISTER_ACTIONS_RECEIVE_RESPONSE',
	REGISTER_ACTIONS_GET_EMAIL_BY_CODE: 'REGISTER_ACTIONS_GET_EMAIL_BY_CODE',
	REGISTER_ACTIONS_VALIDATION_USER_IS_NEW: 'REGISTER_ACTIONS_VALIDATION_USER_IS_NEW',
	REGISTER_ACTIONS_RECEIVE_RESPONSE_EMAIL_BY_CODE: 'REGISTER_ACTIONS_RECEIVE_RESPONSE_EMAIL_BY_CODE',
	REGISTER_ACTIONS_HANDLE_USER_INFO: 'REGISTER_ACTIONS_HANDLE_USER_INFO',
	REGISTER_ACTIONS_RESET: 'REGISTER_ACTIONS_RESET'
}

export const RESET_PASSWORD = {
	RESET_PASSWORD_USER: 'RESET_PASSWORD_USER',
	RESET_PASSWORD_RECEIVE_RESPONSE: 'RESET_PASSWORD_RECEIVE_RESPONSE',
	RESET_PASSWORD_GET_EMAIL_BY_CODE: 'RESET_PASSWORD_GET_EMAIL_BY_CODE',
	RESET_PASSWORD_RESET_VALUES: 'RESET_PASSWORD_RESET_VALUES',
	RESET_PASSWORD_RECEIVE_RESPONSE_EMAIL_BY_CODE: 'RESET_PASSWORD_RECEIVE_RESPONSE_EMAIL_BY_CODE',
	RESET_PASSWORD_HANDLE_USER_INFO: 'RESET_PASSWORD_HANDLE_USER_INFO'
}

export const USERS_ACTIONS = {
	USERS_ACTIONS_HANDLE_VALUES: 'USERS_ACTIONS_HANDLE_VALUES',

  USERS_ACTIONS_DELETE_FILTERS: 'USERS_ACTIONS_DELETE_FILTERS',

	USERS_ACTIONS_LIST_USERS: 'USERS_ACTIONS_LIST_USERS',
	USERS_ACTIONS_RECEIVE_RESPONSE_LIST_USERS: 'USERS_ACTIONS_RECEIVE_RESPONSE_LIST_USERS',

	USERS_ACTIONS_GET_INFO: 'USERS_ACTIONS_GET_INFO',
	USERS_ACTIONS_RECEIVE_RESPONSE_GET_INFO: 'USERS_ACTIONS_RECEIVE_RESPONSE_GET_INFO',

	USERS_ACTIONS_SENT_INVITATION: 'USERS_ACTIONS_SENT_INVITATION',
	USERS_ACTIONS_RECEIVE_RESPONSE_SENT_INVITATION: 'USERS_ACTIONS_RECEIVE_RESPONSE_SENT_INVITATION',

	USERS_ACTIONS_HANDLE_USER_INVITED_FIELDS: 'USERS_ACTIONS_HANDLE_USER_INVITED_FIELDS',

	USERS_ACTIONS_UPDATE_LIST_USERS: 'USERS_ACTIONS_UPDATE_LIST_USERS',

	USERS_ACTIONS_RESET_VALUES: 'USERS_ACTIONS_RESET_VALUES',

  USERS_ACTIONS_FILTERS_RESET: 'USERS_ACTIONS_FILTERS_RESET',

	USERS_ACTIONS_NEXT_PAGE: 'USERS_ACTIONS_NEXT_PAGE',
	USERS_ACTIONS_BACK_PAGE: 'USERS_ACTIONS_BACK_PAGE',

	
	USERS_ACTIONS_NEXT_PAGE_DETAIL: 'USERS_ACTIONS_NEXT_PAGE_DETAIL',
	USERS_ACTIONS_BACK_PAGE_DETAIL: 'USERS_ACTIONS_BACK_PAGE_DETAIL',
	
	USERS_ACTIONS_DASHBOARD_NEXT_PAGE: 'USERS_ACTIONS_DASHBOARD_NEXT_PAGE',
	USERS_ACTIONS_DASHBOARD_BACK_PAGE: 'USERS_ACTIONS_DASHBOARD_BACK_PAGE',

	USERS_ACTIONS_GET_ASSOCIATE_DETAIL: 'USERS_ACTIONS_GET_ASSOCIATE_DETAIL',
	USERS_ACTIONS_RECEIVE_RESPONSE_GET_ASSOCIATE_DETAIL: 'USERS_ACTIONS_RECEIVE_RESPONSE_GET_ASSOCIATE_DETAIL',

	USER_ACTIONS_GET_INFO_PROFILE: 'USER_ACTIONS_GET_INFO_PROFILE',
	USER_ACTIONS_RECEIVE_RESPONSE_GET_INFO_PROFILE: 'USER_ACTIONS_RECEIVE_RESPONSE_GET_INFO_PROFILE',

	USERS_ACTIONS_DELETE_USER: 'USERS_ACTIONS_DELETE_USER',
	USERS_ACTIONS_RECEIVE_RESPONSE_DELETE_USER: 'USERS_ACTIONS_RECEIVE_RESPONSE_DELETE_USER',

  USERS_ACTIONS_UPDATE_USER_INFO: 'USERS_ACTIONS_UPDATE_USER_INFO',
	USERS_ACTIONS_UPDATE_USER_INFO_PROFILE: 'USERS_ACTIONS_UPDATE_USER_INFO_PROFILE',
	USERS_ACTIONS_RECEIVE_RESPONSE_UPDATE_USER_INFO: 'USERS_ACTIONS_RECEIVE_RESPONSE_UPDATE_USER_INFO',
	
	USERS_ACTIONS_RESENT_INVITATION: 'USERS_ACTIONS_RESENT_INVITATION',
	USERS_ACTIONS_RECEIVE_RESPONSE_RESENT_INVITATION: 'USERS_ACTIONS_RECEIVE_RESPONSE_RESENT_INVITATION',

	USERS_ACTIONS_UPDATE_IMAGE_PICTURE_USER_ACTIVE: 'USERS_ACTIONS_UPDATE_IMAGE_PICTURE_USER_ACTIVE',
	USERS_ACTIONS_RECEIVE_RESPONSE_UPDATE_IMAGE_PICTURE_USER_ACTIVE: 'USERS_ACTIONS_RECEIVE_RESPONSE_UPDATE_IMAGE_PICTURE_USER_ACTIVE',

	USERS_ACTIONS_CANCEL_INVITATION: 'USERS_ACTIONS_CANCEL_INVITATION',
	USERS_ACTIONS_RECEIVE_RESPONSE_CANCEL_INVITATION: 'USERS_ACTIONS_RECEIVE_RESPONSE_CANCEL_INVITATION',
	
	USERS_ACTIONS_RESET_VALUES_UPLOAD_IMAGE: 'USERS_ACTIONS_RESET_VALUES_UPLOAD_IMAGE',

	USERS_ACTIONS_HANDLE_VALUES_UPDATE_INFO_USER: 'USERS_ACTIONS_HANDLE_VALUES_UPDATE_INFO_USER',
	USERS_ACTIONS_UPDATE_USER_ACTIVE: 'USERS_ACTIONS_UPDATE_USER_ACTIVE',
  USERS_ACTIONS_GO_TO_PAGE: 'USERS_ACTIONS_GO_TO_PAGE',
  USERS_ACTIONS_DASHBOARD_GO_TO_PAGE: 'USERS_ACTIONS_DASHBOARD_GO_TO_PAGE',
  
  USERS_ACTION_HANDLE_UPDATE_PASSWORD_UI: 'USERS_ACTION_HANDLE_UPDATE_PASSWORD_UI',
  USERS_ACTIONS_RESET_PASSWORD: 'USERS_ACTIONS_RESET_PASSWORD',
  USERS_ACTIONS_RESET_PASSWORD_RECEIVE: 'USERS_ACTIONS_RESET_PASSWORD_RECEIVE',
  USERS_ACTIONS_RESET_PASSWORD_RESET_VALUES: 'USERS_ACTIONS_RESET_PASSWORD_RESET_VALUES',
  USERS_ACTIONS_RESET_PASSWORD_RESET_VALUES_FORM: 'USERS_ACTIONS_RESET_PASSWORD_RESET_VALUES_FORM',
  USERS_ACTIONS_CHANGE_ORDER: 'USERS_ACTIONS_CHANGE_ORDER'
}
// ACTIONS SAGA
export const SAGA_GET_REQUEST_API = 'ACTION_SAGA_GET_REQUEST_API';
export const SAGA_RECEIVE_DATA = 'ACTION_SAGA_RECEIVE_DATA';

export const SAGA_GET_COMMENTS_BY_ID = 'ACTION_SAGA_GET_COMMENTS_BY_ID';
export const SAGA_GET_RECEIVE_COMMENTS_BY_ID = 'ACTION_SAGA_GET_RECEIVE_COMMENTS_BY_ID';

